<button
  class="evaluate-button"
  mat-icon-button
  [matTooltip]="'INBOX.RESPONSE_EVALUATION.HELPFUL' | translate"
  (click)="openEvaluateModal(true, message())"
>
  <mat-icon inline="true" class="evaluate-icon">thumb_up</mat-icon>
</button>
<button
  class="evaluate-button"
  mat-icon-button
  [matTooltip]="'INBOX.RESPONSE_EVALUATION.NOT_HELPFUL' | translate"
  (click)="openEvaluateModal(false, message())"
>
  <mat-icon inline="true" class="evaluate-icon">thumb_down</mat-icon>
</button>
